// extracted by mini-css-extract-plugin
export default {"uploadButton":"OXcqnozzEBP8Ds0zk1gi","uploadButtonImage":"gt3UPHIVmzWHdsRGqZrL"};